import EnumDataSource from "../utils/enum-data-source.util";

const usStates = {
  AK: "Alaska",
  AL: "Alabama",
  AR: "Arkansas",
  AZ: "Arizona",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DC: "District Of Columbia",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  IA: "Iowa",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  MA: "Massachusetts",
  MD: "Maryland",
  ME: "Maine",
  MI: "Michigan",
  MN: "Minnesota",
  MO: "Missouri",
  MS: "Mississippi",
  MT: "Montana",
  NC: "North Carolina",
  ND: "North Dakota",
  NE: "Nebraska",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NV: "Nevada",
  NY: "New York",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VA: "Virginia",
  VT: "Vermont",
  WA: "Washington",
  WI: "Wisconsin",
  WV: "West Virginia",
  WY: "Wyoming",
};

const US_STATES = new EnumDataSource(usStates);

const canadaProvinces = {
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland and Labrador",
  NS: "Nova Scotia",
  NT: "Northwest Territories",
  NU: "Nunavut",
  ON: "Ontario",
  PE: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  YT: "Yukon",
};

const CANADA_PROVINCES = new EnumDataSource(canadaProvinces);

const usVirginIslandsTerritories = {
  SX: "Saint Croix",
  ST: "Saint Thomas",
  SJ: "Saint John",
};

const US_VIRGIN_ISLANDS_TERRITORIES = new EnumDataSource(
  usVirginIslandsTerritories
);

export { US_STATES, CANADA_PROVINCES, US_VIRGIN_ISLANDS_TERRITORIES };

export const US_COUNTRY_VALUE = "United States of America";
export const CANADA_COUNTRY_VALUE = "Canada";
export const BAHAMAS_COUNTRY_VALUE = "Bahamas";
export const US_VIRGIN_ISLANDS_COUNTRY_VALUE = "US Virgin Islands";
const countries = {
  [US_COUNTRY_VALUE]: "USA",
  [CANADA_COUNTRY_VALUE]: CANADA_COUNTRY_VALUE,
  [BAHAMAS_COUNTRY_VALUE]: BAHAMAS_COUNTRY_VALUE,
  [US_VIRGIN_ISLANDS_COUNTRY_VALUE]: US_VIRGIN_ISLANDS_COUNTRY_VALUE,
};
export const COUNTRIES = new EnumDataSource(countries);
